<template>
  <div :class="styleClasses.card">
    <!-- <div :class="styleClasses.card_header">
      <span class="me-2">{{ formatTimestamp(reservation.reservation_time, 'MM/DD HH:mm') }}</span>
      <span>{{ reservation.demandSchedule?.demandArea.label || '--' }}</span>
    </div> -->
    <div :class="styleClasses.card_body">
      <div :class="styleClasses.card_body_content">
        <div>
          <div>
            <!-- 乗降車地点 -->
            <div :class="styleClasses.locations">
              <div
                :class="styleClasses.location"
                v-for="(l, i) in locations" :key="i"
                @click="mapWindowOpen(l)">
                <div>
                  <i class="fa-regular fa-map-location-dot"/>
                  <span class="mt-1">{{ i === 0 ? '乗' : i === locations.length - 1 ? '降' : '経' }}</span>
                </div>
                <div>
                  <div>{{ formatTimestamp(l.time, 'HH:mm') }}</div>
                  <div v-if="l.address">{{ removeZipPref(l.address) }}</div>
                  <div>{{ l.title }}</div>
                  <ApproximateWarning v-if="l.is_approximate === 1"/>

                  <div :class="s.customers">
                    <div
                      :class="[s.customer, isCompleted && 'py-2']"
                      v-for="(cus, j) in l.customers" :key="j">
                      <div>
                        <div :class="s.customer_name">
                          <div :style="{ backgroundColor: cus.color }"><i :class="cus.type === 'pickup' ? 'fa-solid fa-arrow-up' : 'fa-solid fa-arrow-down'"/></div>
                          <div :style="{ color: cus.color }" class="mx-2">{{ totalPassenger(cus) }} 名</div>
                          <div :style="{ color: cus.color }">{{ cus.user?.username ? `${cus.user?.username} 様`: '不明' }}</div>
                        </div>
                      </div>
                      <div v-if="!isCompleted">
                        <LargeBtn
                          v-if="cus.flag < 900"
                          :style="{ width: '120px' }"
                          :status-flag="cus.btnStatus.flag"
                          :office-id="officeId"
                          :color="cus.btnStatus.color"
                          :disabled="cus.btnStatus.isDisabled"
                          @click.stop="changeDCFlag(l, cus)">{{ cus.btnStatus.label }}</LargeBtn>
                        <div v-else class="py-3">キャンセル済み</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                </div>
              </div>
            </div>
          </div>
          <!-- 顧客一覧 -->
          <div class="mt-2">
            <ul>
              <li
                v-for="c in customers" :key="c.id"
                class="mt-2 p-2 bdr rounded">
                <div class="d-flex align-items-center justify-content-between" :style="{ flexWrap: 'wrap' }"> 
                  <div class="me-2">
                    <div class="d-flex align-items-center">
                      <i class="fa-solid me-2" :class="c.route === 1 || c.route === 5 ? 'fa-comments' : 'fa-user'"/>
                      <div>{{ c.user.username }} 様</div>
                      <div class="ms-2">
                        <div>&yen; {{ price(c) || price(c) === 0 ? price(c).toLocaleString() : '--' }}</div>
                      </div>
                    </div>
                    <div :class="s.passengers">
                      <span class="me-2" v-for="dp in passengers(c)" :key="dp.id">{{ getPassengerTypeLabel(dp.type) }}: {{ dp.count }}名</span>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div>
                      <button
                        v-if="c.user.tel"
                        @click="openCustomerInfoModal(c)"
                        :class="[styleClasses.button, styleClasses.gray]" class="me-2">
                        <i class="fa-solid fa-user"></i>
                      </button>
                      <button
                        v-if="customerLineUser(c)"
                        @click="openCustomerOperatorThread(c)"
                        :class="[styleClasses.button, styleClasses.gray]" class="me-2">
                        <i class="fa-solid fa-comments"></i>
                      </button>
                      <button
                        @click="openDemandOrderResultsModal(c)"
                        :class="[styleClasses.button, styleClasses.gray]" class="me-2">
                        実績
                        <i class="fa-regular fa-memo ms-2"></i>
                      </button>
                    </div>
                    <div v-if="!isCompleted">
                      <div class="d-flex align-items-center" v-if="c.flag < 900">
                        <button
                          @click.stop="cancelDemand(c.id)"
                          :disabled="false"
                          :class="s.btn">キャンセル</button>
                      </div>
                      <div class="d-flex align-items-center" v-else>
                        キャンセル済み
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="c.memo" v-html="c.memo.memo" class="n2br mt-2"/>
              </li>
            </ul>
          </div>
          <!-- オペレーターとチャット -->
          <div class="mt-2">
            <button
              @click="openOperatorThread"
              :class="[styleClasses.button, styleClasses.gray]">
              <i class="fa-regular fa-comments me-2"/>オペレーターに連絡
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';
import LargeBtn from '../LargeBtn.vue';
import ApproximateWarning from '../ApproximateWarning.vue';

export default {
  name: 'order-demand',
  mixins: [cf],
  props: {
    reservation: Object,
    styleClasses: Object,
    isPriorityTop: Boolean,
  },
  components: {
    LargeBtn,
    ApproximateWarning,
  },
  data() {
    return {
      statusBtns: [
        {
          flag: 2,
          label: '迎車',
          activeFlags: [1],
          color: 'red',
          displayType: 'pickup',
        },
        {
          flag: 11,
          label: '到着',
          activeFlags: [2],
          color: 'blue',
          displayType: 'pickup',
        },
        {
          flag: 21,
          label: '実車',
          activeFlags: [11, 21, 31],
          color: 'yellow',
          displayType: 'pickup',
        },
        {
          flag: 31,
          label: '完了',
          activeFlags: [1, 2, 11, 21, 31],
          color: 'lightgreen',
          displayType: 'destination',
        },
      ],
    };
  },
  computed: {
    ...mapState(['user', 'helper', 'modal']),
    officeId() {
      return this.user?.offices?.[0]?.id || null;
    },
    isCompleted() {
      return this.customers.every((c) => c.flag >= 31);
    },
    colors() {
      return this.helper.master.system?.demandMarkerColors || [];
    },
    formatReservation() {
      return this.formatDemandReservation(this.reservation, this.colors);
    },
    locations() {
      return this.formatReservation.locations.map((l) => ({
        ...l,
        customers: l.customers.map((c) => ({
          ...c,
          btnStatus: this.btnStatus(l, c),
        })),
      }));
    },
    customers() {
      return this.reservation.demandCustomers;
    },
    hasValidCruisingOrder() {
      const otherDemandOrders = this.user.orders.filter((o) => o.foreign_type === 31 && this.reservation.id !== o.id);
      if (otherDemandOrders.length === 0) return false;
      return otherDemandOrders.some((order) => order.demandCustomers.some((customer) => [2, 11, 21].includes(customer.flag)));
    },
  },
  methods: {
    price(customer) {
      const orderResult = customer.demandOrderResult;
      if (orderResult) return orderResult.price_discounted;
      return customer.price;
    },
    passengers(customer) {
      if (!customer.demandPassengers) return [];
      const resultPassenger = customer.demandPassengers?.filter((dp) => dp.record_type === 21) || [];
      const estimatePassenger = customer.demandPassengers?.filter((dp) => dp.record_type === 11) || [];
      return resultPassenger.length ? resultPassenger : estimatePassenger;
    },
    totalPassenger(customer) {
      const passengers = this.passengers(customer);
      return passengers.reduce((a, c) => a + c.count, 0);
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getPassengerTypeLabel(name) {
      return this.reservation.demandSchedule?.demandArea?.passenger_types?.find((type) => type.name === name)?.label;
    },

    btnStatus(location, customer) {
      const type = location.type;

      let result = {
        flag: null,
        label: '不明',
        activeFlags: [],
        color: 'gray',
      };

      const targetBtn = this.statusBtns.find((btn) => btn.activeFlags.includes(customer.flag) && btn.displayType === type);
      if (targetBtn) result = targetBtn;

      const order = this.formatReservation.locations.findIndex((l) => `${l.lat},${l.lng},${l.time}` === `${location.lat},${location.lng},${location.time}`);
      const beforeLocations = this.formatReservation.locations.filter((_, i) => i < order);

      // この地点より前の地点の実車が全て完了しているか
      const passedBeforePickupsStatus = beforeLocations.every((l) => l.customers.every((cus) => l.type !== 'pickup' || cus.flag >= 21));
      // この地点より前の地点の降車が全て完了しているか
      const passedBeforeDestinationStatus = beforeLocations.every((l) => l.customers.every((cus) => l.type !== 'destination' || cus.flag >= 31));
      // この予約の運行が開始されているか
      const isStarted = this.reservation.demandCustomers.some((dc) => [2, 11, 21, 31].includes(dc.flag));
      // この予約が直近か
      const isPriorityTop = this.isPriorityTop;

      // 直近でもなく開始もされていない場合にはdisabled
      // そのほかの場合には予約の状況による
      const isDisabled = !(isPriorityTop || isStarted)
        ? true 
        : !passedBeforePickupsStatus || !passedBeforeDestinationStatus || (type === 'pickup' && customer.flag >= 21) || (type === 'destination' && customer.flag >= 31);

      return { ...result, isDisabled: isDisabled || !targetBtn };
    },

    mapWindowOpen(location) {
      const position = `${location.lat},${location.lng}`;
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${position}&travelmode=driving`, '_blank');
    },

    changeDCFlag(location, customer) {
      if (this.btnStatus(location, customer).isDisabled) return;

      if (this.btnStatus(location, customer).flag === 2) {
        const target = new Date(customer.datetime);
        const now = new Date();
        const diffMs = Math.abs(target - now); // ミリ秒差
        const diffMinutes = diffMs / (1000 * 60);
        const START_CONFIRM_DIFF = 15;
        if (diffMinutes > START_CONFIRM_DIFF && now < target) {
          if (!confirm(`予約時間は${START_CONFIRM_DIFF}分以上先ですが、迎車を開始してよろしいですか？`)) return;
        }
      }
      
      this.showLoading();
      const data = {
        id: customer.id,
        flag: this.btnStatus(location, customer).flag,
        revisionUserId: this.user.id,
      };

      this.axios({
        method: 'POST',
        url: '/v1/demandCustomer/update',
        data,
      })
        .then(async (response) => {
          const res = response.data;
          if (!res.updated) alert('予約ステータスの更新に失敗しました。最新の状態に更新します。');
          // 迎車開始時にdemandOrderResultを登録、完了時に更新
          else if ([2, 31].includes(data.flag)) await this.registDemandOrderResult(customer);

          // 完了時はDemandOrderResultモーダルを表示する（現状「東神楽」のみ）
          const configKey = this.reservation.demandSchedule?.demandArea?.config_key;
          const showResultModalKeys = ['higashiKagura', 'abira'];
          if (data.flag === 31 && showResultModalKeys.includes(configKey)) this.openDemandOrderResultsModal(customer);

          // reservation.codeを入れてreplace(ステータス操作したorderに戻ってくるため)
          this.$router.replace({ path: '/order', query: { code: this.reservation.code } });
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
          this.hideLoading();
        })
        .finally(() => {
          this.$store.dispatch('dispatch/getReservations', { hideLoading: true });
          // ネイティブアプリのバッジ更新（敢えて完了時に絞らない）
          cf.updateNativeAppBadges(this.helper);
        });
    },

    registDemandOrderResult(customer) {
      const demandOrderResult = customer.demandOrderResult || {};
      const endpoint = !demandOrderResult.id ? 'create' : 'update';
      this.showLoading();

      const data = {};

      if (endpoint === 'create') {
        data.demand_customer_id = customer.id;
        data.price = customer.price || 0;
        data.passenger_count = Object.fromEntries(this.passengers(customer).map((dp) => [dp.type, dp.count]));
      } else {
        // backend側で走行距離を計算して格納するため完了時にもupdateを叩く必要がある
        data.id = demandOrderResult.id;
      }

      this.axios({
        method: 'POST',
        url: `/v1/demandOrderResult/${endpoint}`,
        data,
      })
        .then(() => {})
        .catch((error) => {
          console.log(error);
          alert('配車報告処理中にエラーが発生しました。再度お試しください。');
          this.hideLoading();
        })
        .finally(() => {
          this.$store.dispatch('user/update');
        });
    },

    openCustomerInfoModal(customer) {
      const args = {
        modalName: 'CustomerInfo',
        modalTitle: '顧客情報',
        data: {
          userId: customer.user.id,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },

    openDemandOrderResultsModal(customer) {
      const args = {
        modalName: 'DemandOrderResult',
        modalTitle: '配車結果',
        data: {
          reservationId: this.reservation.id,
          demandCustomerId: customer.id,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },

    async cancelDemand(customerId) {
      if (!confirm('この顧客をキャンセルしますか？\nこの操作は取り消せません。')) return;
      const data = {
        demand_customer_id: customerId,
        route: 'driver',
        user_id: this.user.id,
      };
      this.showLoading();
      await this.axios({
        method: 'POST',
        url: '/v1/demand/cancel',
        data,
      })
        .then(() => {})
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });

      this.$store.dispatch('dispatch/getReservations', { hideLoading: true });
    },
    openOperatorThread() {
      const userIds = [this.user.id];
      this.$store.dispatch('modal/contents/showModal', {
        modalName: 'ThreadMessages',
        modalTitle: 'オペレーター',
        modalWidth: '95%',
        data: { userIds, officeId: this.user.offices[0]?.id },
      });
    },
    openCustomerOperatorThread(customer) {
      const lineUser = this.customerLineUser(customer);
      if (!lineUser?.user_id) return;
      const userIds = [this.user.id, lineUser.user_id];
      this.$store.dispatch('modal/contents/showModal', {
        modalName: 'ThreadMessages',
        modalTitle: `${customer.user.username} 様, オペレーター`,
        modalWidth: '95%',
        data: { userIds, officeId: this.user.offices[0]?.id },
      });
    },
  },
};
</script>

<style lang="scss" module="s">
.customers {
  > * {
    margin-top: 12px;
  }
}
.customer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .customer_name {
    align-items: center;
    display: flex;
    > :nth-child(1) {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      border-radius: 60%;
      color: #ffffff;
      margin-right: 6px;
      > i {
        font-size: 16px !important;
      }
    }
  }
}

.passengers {
  > span {
    font-size: 20px;
  }
}

.btn {
  background-color: var(--primary-red);
  color: white;
  cursor: pointer;
  border: 4px solid;
  padding: 0 16px;
  height: 50px;
  font-weight: bold;
  border-color: rgba(255, 255, 255, 0.2) rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.2) rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  white-space: nowrap;
  &.blue {
    background-color: var(--primary-gray);
  }
  &:disabled {
    border-color: transparent;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: -4px; left: -4px;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border-radius: 4px;
      background-color: rgba(#000000, .5);
      mix-blend-mode: multiply;
    }
  }
}
</style>
